import { render, staticRenderFns } from "./StepFlow.vue?vue&type=template&id=6be0438b&"
import script from "./StepFlow.vue?vue&type=script&lang=js&"
export * from "./StepFlow.vue?vue&type=script&lang=js&"
import style0 from "./StepFlow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be0438b')) {
      api.createRecord('6be0438b', component.options)
    } else {
      api.reload('6be0438b', component.options)
    }
    module.hot.accept("./StepFlow.vue?vue&type=template&id=6be0438b&", function () {
      api.rerender('6be0438b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/oficialNumeration/StepFlow.vue"
export default component.exports